import React from 'react';

import Moment from 'moment';

import {
  getUniqueAttributes,
} from '../../../../../custom_js/getUniqueAttributes.js';
import ExplanationAttributes
  from '../../../../snippets/ExplanationAttributes/ExplanationAttributes.jsx';
import ScheduleDates from '../../../../snippets/ScheduleDates.jsx';
import ScheduleFilter from '../../../../snippets/ScheduleFilter.jsx';
import Session from '../../../../snippets/Session.jsx';

const compareDates = (a, b) => {
  if (Moment.utc(a).isBefore(b)) {
    return -1
  } else if (Moment.utc(a).isAfter(b)) {
    return 1
  }
  return 0
}

const compareByName = (a, b) => {
  if (a.name < b.name) {
    return -1
  } else if (a.name > b.name) {
    return 1
  }
  return 0
}

const compareByHallNumber = (a, b) => {
  if (a.hall_number < b.hall_number) {
    return -1
  } else if (a.hall_number > b.hall_number) {
    return 1
  }
  return 0
}

class MoviePageSchedule extends React.Component {
  constructor(props) {
    super(props)
    this.makeFiltersOptions = this.makeFiltersOptions.bind(this);
    this.handleDateChande = this.handleDateChande.bind(this);
    this.handleFormatFilterChange = this.handleFormatFilterChange.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.callbackUpdatedAttributes = this.callbackUpdatedAttributes.bind(this);
    let defaults = this.makeFiltersOptions();

    this.state = {
      dates: defaults.dates,
      formats: defaults.formats,
      formatsById: defaults.formatsById,
      dateFilter: defaults.dates[0],
      formatFilter: null,
      activeAttributes: [],
    }
  }

  makeFiltersOptions() {
    let uniqueDates = new Set();
    let uniqueFormats = {};
    let uniqueFormatsArray = [];
    for (let session of this.props.film.Sessions) {
      // формируем сет уникальных дат в расписаниее
      uniqueDates.add(Moment.utc(session.ShowTime).format("YYYY-MM-DD"))
      // уникальные залы / форматы делаем через объект
      for (let attr of session.attributes) {
        if (attr.type === "format") {
          uniqueFormats[attr.type + "-" + attr.short_name] = attr
        }
      }
    }
    let uniqueDatesArray = Array.from(uniqueDates)
    uniqueDatesArray.sort(compareDates)
    Object.keys(uniqueFormats).forEach(formatKey => {
      uniqueFormats[formatKey].id = formatKey;
      uniqueFormatsArray.push(uniqueFormats[formatKey])
    })
    uniqueFormatsArray.sort(compareByName)
    return {
      dates: uniqueDatesArray,
      formats: uniqueFormatsArray,
      formatsById: uniqueFormats
    }
  }

  handleDateChande(val) {
    this.setState({ dateFilter: val })
  }

  handleFormatFilterChange(val) {
    this.setState(prevState => ({ formatFilter: prevState.formatsById[val] }))
  }

  applyFilters() {
    let byHall = {}
    let byHallArray = [];

    for (let session of this.props.film.Sessions) {
      let dateValid = true;
      let formatValid = true;

      dateValid = Moment.utc(session.ShowTime).isSame(Moment.utc(this.state.dateFilter), 'day');

      if (this.state.formatFilter) {
        formatValid = false
        for (let attr of session.attributes) {
          if (attr.name === this.state.formatFilter.name) {
            formatValid = true;
            break;
          }
        }
      }

      if (dateValid && formatValid) {
        if (!byHall[session.hall_number]) {
          byHall[session.hall_number] = {
            hall_number: session.hall_number,
            hall_name: session.hall_name,
            sessions: [session]
          }
        } else {
          byHall[session.hall_number].sessions.push(session)
        }
      }
    }

    for (let key in byHall) {
      byHallArray.push(byHall[key]);
    }

    byHallArray.sort(compareByHallNumber)

    return byHallArray
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   if (nextState.activeAttributes !== this.state.activeAttributes) {
  //     return true;
  //   }
  //   return false
  // }

  callbackUpdatedAttributes({ attributes = [] } = {}) {
    const activeAttributes = attributes.filter(_ => _.isActive)
    this.setState(() => ({ activeAttributes }))
  }

  /**
 * Get unique filteredAttributes attributes by sessions film
 */
  getUniqueAttrByFilms(filteredFilms) {
    const allAttributes = filteredFilms
      .map(_ => _.sessions)
      .flat(1)
      .map(_ => _.attributes)
      .flat(1)

    const uniqAttrs = getUniqueAttributes({ allAttributes })

    return uniqAttrs
  }

  /**
   * Get unique attributes by filtered films
   * filteredAttributes
   */
  getAttrs(filteredFilms) {
    let uniqAttrs = this.getUniqueAttrByFilms(filteredFilms)

    uniqAttrs = uniqAttrs.map(_ => ({
      ..._,
      // isActive: _.isActive != undefined ? _.isActive : false, // mock, for selected multiple attributes at once
      isActive: false,
      isDisabled: false, // 2do: remove this attr. Not used
      marginBottom: ''
    }))


    // -- other func
    // For uniqAttrs set the isActive property based on activeAttributes
    uniqAttrs = uniqAttrs.map(_uqAttr => {
      let _item = _uqAttr
      // Знайти унікальний атрибут в активних атрибутах і скопіювати його isActive 
      this.state.activeAttributes.forEach(_actAttr => {
        if (
          _uqAttr.name === _actAttr.name &&
          _uqAttr.type === _actAttr.type &&
          _uqAttr.short_name === _actAttr.short_name &&
          _uqAttr.description === _actAttr.description
        ) {
          _item = _actAttr
        }
      })

      return _item
    })

    return uniqAttrs
  }

  render() {
    const hals = this.applyFilters();
    if (hals.length === 0) {
      return null;
    }

    // const ExplAttrWithAnimation = () => <ExplanationAttributes
    //   uniqueAttributes={this.getAttrs(hals)}
    //   cssDesktopClassForPage={this.props.cssDesktopClassForPage}
    //   cssMobileClassForPage={this.props.cssMobileClassForPage} />

    // 2do: розібратись чому з функцією колбек пропадає анімація
    const ExplAttr = () => <ExplanationAttributes
      uniqueAttributes={this.getAttrs(hals)}
      callbackUpdatedAttributes={this.callbackUpdatedAttributes}
      cssDesktopClassForPage={this.props.cssDesktopClassForPage}
      cssMobileClassForPage={this.props.cssMobileClassForPage} />

    return (
      <div className="schedule">
        <div className="wd">

          <h2 className="schedule__heading">Сеанси</h2>
          <ScheduleDates dates={this.state.dates} setDate={this.handleDateChande} currentDate={this.state.dateFilter} />
          <div className="schedule__filters">
            <ScheduleFilter emptyLabel="Усі формати" options={this.state.formats} handleFilterChange={this.handleFormatFilterChange} selectedOption={this.state.formatFilter} />
          </div>
          <div className="schedule__halls">
            {hals.map(hall =>
              <div className="schedule__hall" key={hall.hall_number}>
                <p className="schedule__hall__name">{hall.hall_name}</p>

                <div className="schedule__hall__sessions">
                  {hall.sessions.map(session =>
                    <Session session={session} key={session.CinemaId + "-" + session.Id} dt={session.ShowTime} handleSessionClick={this.props.handleSessionClick} />
                  )}
                </div>
              </div>
            )}
          </div>

          <ExplAttr />

          {/* <MoviePageScheduleNotifySaleStarts /> */}
        </div>
      </div>
    )
  }
}

export default MoviePageSchedule


// WEBPACK FOOTER //
// ./src/components/pages/MoviePage/impl/MoviePageSchedule/MoviePageSchedule.jsx